import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { PlanoVinculadoEntidade } from '@entidades';
import { PlanoService } from '@services';
import { PlanoItemBD } from './PlanoItemBD';
import { PlanoItemCD } from './PlanoItemCD';
import { ListaPlanos, MasterPage } from '@components';
import { NumFuncionalidade } from '../../helpers/BloqueioFuncionalidade';

export interface ComboRefItem {
  Name: string;
  Key: string;
}

export const Extrato: React.FC = (props) => {
  const history = useHistory();

  const [AlertText, setAlertText] = useState<string>("");
  const [pensionista, setPensionista] = useState(false);
  const [assistido, setAssistido] = useState(false);
  const [ativo, setAtivo] = useState(false);
  const [planos, setPlanos] = useState<Array<PlanoVinculadoEntidade>>([]);
  const [plano, setPlano] = useState<PlanoVinculadoEntidade | null>(null);
  const [cdPlano, setCdPlano] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const pensionista = localStorage.getItem("pensionista") === "true";
        setPensionista(pensionista);

        const planos = await PlanoService.Buscar();

        const temPlano = planos.length > 0;
        setPlanos(planos);
        setPlano(temPlano ? planos[0] : null);
        setCdPlano(temPlano ? planos[0].CD_PLANO : "");
      }
      catch (err) {
        if (err.message.indexOf("401") > -1) {
          history.push("/login");
        }
      }
    })();
  }, []);

  async function carregarPlano(CdPlano: string) {
    const planoSelecionado = planos.filter(plano => plano.CD_PLANO === CdPlano)[0];

    setCdPlano(CdPlano);
    setPlano(planoSelecionado);
  };

  return (
    <MasterPage Funcionalidade={NumFuncionalidade.EXTRATO} {...props}>
      <ListaPlanos planos={planos} onChange={carregarPlano} cdPlanoAtivo={cdPlano} />

      {plano !== null && plano.CD_PLANO === "0001" &&
        <PlanoItemBD
          plano={plano}
        />}

      {plano !== null && plano.CD_PLANO === "0002" &&
        <PlanoItemCD
          plano={plano}
        />}
    </MasterPage>

  );
}
